import AuditUnitCondition from "./AuditUnitCondition"
import { WizardPictureStep } from "../../ui/wizard"
import AuditUnitConfirm from "./AuditUnitConfirm"
import { getExtensionFromMimeType } from '../../../utilities/imageUtilities'
import AuditUnitAddPhoto from "./AuditUnitAddPhoto"

export default function AuditUnitSteps({
  auditUnit,
  auditData,
  setAuditData,
  setIsEditing
}) {
  const handleImageSubmit = (title, image) => {
    if (image) {
      const renamedFile = new File([image], `${title}${getExtensionFromMimeType(image.type)}`, { type: image.type })
      setAuditData((previous) => {
        return {
          ...previous,
          images: {
            ...previous.images,
            [title]: renamedFile
          }
        }
      })
    }
  }

  const steps = [
    {
      Component: AuditUnitCondition,
      props: {
        auditUnit: auditUnit,
        auditData: auditData,
        setAuditData: setAuditData
      }
    },
    ...Object.entries(auditData.images).map(([title, image]) => ({
      Component: WizardPictureStep,
      props: {
        title: title,
        handleSubmit: (image) => handleImageSubmit(title, image),
        previewable: true,
        image: image
      }
    })),
    {
      Component: AuditUnitAddPhoto,
      props: {
        auditData: auditData,
        setAuditData: setAuditData
      }
    },
    {
      Component: AuditUnitConfirm,
      props: {
        auditUnit: auditUnit,
        auditData: auditData,
        setIsEditing: setIsEditing
      }
    }
  ]

  return auditData.condition === '4'
    ? steps.filter(step => ![WizardPictureStep, AuditUnitAddPhoto].includes(step.Component))
    : steps
}